module.exports = __webpack_public_path__ + "assets/img/block-right-c9226724.png";